import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiShoppingBag, FiCoffee, FiTruck, FiInfo } from 'react-icons/fi';

const Wholesale = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    // In a real app, this would send data to an API
  };

  return (
    <div className="bg-brand-cream min-h-screen">
      {/* Header */}
      <div className="bg-brand-charcoal text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 bg-pattern pointer-events-none"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6">Wholesale African Food Supply</h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            DSGlobal Foundation welcomes enquiries from shops, restaurants, caterers and distributors looking for authentic African food products.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        {/* Target Audience Sections */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-brand-sand text-center">
            <div className="w-16 h-16 bg-brand-green/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiShoppingBag} className="w-8 h-8 text-brand-green" />
            </div>
            <h3 className="text-xl font-bold text-brand-charcoal mb-3">For African Food Shops</h3>
            <p className="text-gray-600 text-sm">Stock your shelves with trusted African staples, packaged for retail sale with clear labelling.</p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-sm border border-brand-sand text-center">
            <div className="w-16 h-16 bg-brand-yellow/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiCoffee} className="w-8 h-8 text-brand-yellow" />
            </div>
            <h3 className="text-xl font-bold text-brand-charcoal mb-3">For Restaurants & Caterers</h3>
            <p className="text-gray-600 text-sm">Consistent supply of authentic ingredients in practical catering sizes to support your kitchen operations.</p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-sm border border-brand-sand text-center">
            <div className="w-16 h-16 bg-brand-red/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiTruck} className="w-8 h-8 text-brand-red" />
            </div>
            <h3 className="text-xl font-bold text-brand-charcoal mb-3">For Distributors & Bulk Buyers</h3>
            <p className="text-gray-600 text-sm">Competitive pricing for volume orders. We arrange reliable dispatch for import/export needs.</p>
          </div>
        </div>

        {/* Form Section */}
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-md border border-brand-sand overflow-hidden">
          <div className="p-8 md:p-12">
            <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-6">Request Wholesale Price List</h2>
            
            <div className="flex items-start text-sm text-brand-charcoal bg-brand-sand p-4 rounded-lg mb-8 border-l-4 border-brand-yellow">
              <SafeIcon icon={FiInfo} className="mr-3 mt-0.5 text-brand-yellow flex-shrink-0" />
              <p>This prototype does not process payments. Final prices, quantities and delivery terms will be confirmed directly after receiving your enquiry.</p>
            </div>

            {isSubmitted ? (
              <div className="text-center py-12 bg-green-50 rounded-xl border border-green-100">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-green-600 text-2xl">✓</span>
                </div>
                <h3 className="text-2xl font-bold text-brand-charcoal mb-2">Enquiry Sent Successfully</h3>
                <p className="text-gray-600 mb-6">Thank you for your interest. Our wholesale team will contact you shortly.</p>
                <button 
                  onClick={() => setIsSubmitted(false)}
                  className="text-brand-green font-semibold hover:underline"
                >
                  Send another enquiry
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Contact Name *</label>
                    <input type="text" id="name" required className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-brand-green focus:border-brand-green outline-none transition-colors" />
                  </div>
                  <div>
                    <label htmlFor="business" className="block text-sm font-medium text-gray-700 mb-1">Business Name *</label>
                    <input type="text" id="business" required className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-brand-green focus:border-brand-green outline-none transition-colors" />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email Address *</label>
                    <input type="email" id="email" required className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-brand-green focus:border-brand-green outline-none transition-colors" />
                  </div>
                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">Phone / WhatsApp *</label>
                    <input type="tel" id="phone" required className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-brand-green focus:border-brand-green outline-none transition-colors" />
                  </div>
                  <div>
                    <label htmlFor="country" className="block text-sm font-medium text-gray-700 mb-1">Destination Country *</label>
                    <input type="text" id="country" required className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-brand-green focus:border-brand-green outline-none transition-colors" />
                  </div>
                  <div>
                    <label htmlFor="products" className="block text-sm font-medium text-gray-700 mb-1">Products of Interest</label>
                    <input type="text" id="products" placeholder="e.g. Fufu flour, Palm oil" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-brand-green focus:border-brand-green outline-none transition-colors" />
                  </div>
                </div>

                <div>
                  <label htmlFor="quantity" className="block text-sm font-medium text-gray-700 mb-1">Estimated Quantity / Volume</label>
                  <input type="text" id="quantity" placeholder="e.g. 1 pallet, 50 boxes" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-brand-green focus:border-brand-green outline-none transition-colors" />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Additional Message</label>
                  <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-md border border-gray-300 focus:ring-brand-green focus:border-brand-green outline-none transition-colors"></textarea>
                </div>

                <div className="pt-4">
                  <button type="submit" className="w-full md:w-auto px-8 py-4 bg-brand-green text-white font-bold rounded-md hover:bg-opacity-90 transition-colors shadow-md">
                    Send Wholesale Enquiry
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Wholesale;